//#region Constants
/**
 * Login token cache key name
 * 
 * @internal
 */
export const LOCAL_SIGNIN_RESULT_CACHE = "LOCAL_STRATEGY_SIGNIN_RESULT_CACHE";

/**
 * Default REST endpoints
 * 
 * @internal
 */
export const DEFAULT_ENDPOINTS = {
  users: "auth/v2/user",
  signIn: "auth/v2/login",
  signOut: "auth/v2/logout",
};
//#endregion Constants
